// extracted by mini-css-extract-plugin
export default {"filters":"ZOgSZv9EL2csvDfQemqg"};